/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { BodyCreateTaskResourceLinkTitle } from './bodyCreateTaskResourceLinkTitle';
import type { BodyCreateTaskResourceLinkDescription } from './bodyCreateTaskResourceLinkDescription';
import type { BodyCreateTaskResourceLinkCitation } from './bodyCreateTaskResourceLinkCitation';

export interface BodyCreateTaskResourceLink {
  link_url: string;
  title?: BodyCreateTaskResourceLinkTitle;
  description?: BodyCreateTaskResourceLinkDescription;
  citation?: BodyCreateTaskResourceLinkCitation;
  auto_generate_metadata?: boolean;
}
